"use strict";import{Overlay as o}from"./Overlay.js";export async function openOverlay(e,n,r,t){return o.open(e,n,r,t)}
//# sourceMappingURL=loader.js.map
